import React, { FC, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import { RedLogo } from 'components/Image'
import { Spacer } from 'components/Utility'
import { TextInput } from 'components/Form'
import { useStringChangeEvent } from 'hooks/form'
import { OrangeButton } from 'components/Button'
import { Description } from 'components/Typography'
import { resetPassword } from 'reducks/auth/operations'
import { push } from 'connected-react-router'
import { State } from 'index'
import { getEmailError } from 'reducks/error/selectors'
import { isValidEmailFormat } from 'reducks/error/operations'
import { initErrorAction } from 'reducks/error/actions'
import { use100vh } from 'react-div-100vh'

const ForgetTemplate: FC = () => {
  const dispatch = useDispatch()
  const emailError = useSelector((state: State) => getEmailError(state))
  const [email, setEmail] = useState<string>('')
  const handleEmail = useStringChangeEvent(setEmail)

  const height = use100vh()

  return (
    <div className={styles.forget} style={{ height: height ?? '100vh' }}>
      <RedLogo />
      <Spacer size={32} />
      <div className={styles.forget__inner}>
        <TextInput
          date-testid={'email'}
          disabled={false}
          error={emailError}
          isFilled={email !== ''}
          label={'メールアドレス'}
          onChange={handleEmail}
          onBlur={() => dispatch(isValidEmailFormat(email))}
          required={true}
          placeholder={'forget@sacri.jp'}
          type={'email'}
          value={email}
        />
        <Spacer size={8} />
        <Description description={'再設定用のメールアドレスを入力してください'} />
        <Spacer size={32} />
        <OrangeButton
          disabled={email === '' || emailError !== ''}
          label={'送信する'}
          onClick={() => dispatch(resetPassword(email))}
          size={'medium'}
          type={'main'}
        />
        <Spacer size={32} />
        <a
          className={`${text.link} ${text.align_center}`}
          role={'button'}
          onClick={() => {
            dispatch(push('/login'))
            dispatch(initErrorAction())
          }}
        >
          トップページに戻る
        </a>
      </div>
    </div>
  )
}

export default ForgetTemplate
